export enum MenuItemIconType {
    None = 0,
    Info = 1,
    Processing = 2,
    Reports = 3,
    Admin = 4,
}

export interface MenuItem {
    id: string;
    icon?: string;
    iconType: MenuItemIconType;
    name: string;
    path?: string;
    onClick?: Function;
    component?: JSX.Element;
    children: MenuItem[];
    order: number;
    emphasize?: boolean;
    hidden?: boolean;
};